<div #parent class="report-sankey-chart__container">
  <svg
    #sankeyChart
    height="360"
    id="sankey">
  </svg>
  <div #sankeyTooltip id="sankey-tooltip">{{ sankeyTooltipText }}</div>
</div>
